<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse"/>
    <scroll-bar>
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Logo from './Logo'
    import SidebarItem from './SidebarItem'
    import ScrollBar from '@/components/ScrollBar'

    export default {
        components: {SidebarItem, ScrollBar, Logo},
        computed: {
            ...mapGetters([
                'sidebar',
                'routers'
            ]),
            routes() {
                // return this.$router.options.routes
                return this.routers
            },
            showLogo() {
                return this.$store.state.settings.sidebarLogo
            },
            isCollapse() {
                return !this.sidebar.opened
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue